<template>
  <div>
    <!-- Modelo de página -->
    <div class="theme-page-section theme-page-section-gray theme-page-section-lg">
      <div class="container">
        <div class="row">
          <!-- Menu -->
          <dashboard-menu class="mt-90" />
          <!-- /Menu -->
          <div class="mt-30 col-md-10">
            <router-view/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardMenu from "@/components/template/DashboardMenu";

export default {
  components: {
    DashboardMenu,
  }
};
</script>
